import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import AOS from "aos";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { companyList } from "../../apis/api/DataApi";
import { useDispatch, useSelector } from "react-redux";
import "aos/dist/aos.css";
import "boxicons/css/boxicons.min.css";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "js-cookie";
import {
  insertTransaction,
  insertRequest,
} from "../../apis/api/NMMBusinessApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const transactionModes = [
  "Bank Transfer",
  "UPI",
  "Cheque",
  "Cash",
  "Online Gateway",
];

const paymentStatuses = ["Advance", "Partial", "Full", "Final Settlement"];

const AddBuisness = () => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: { date: new Date() } });

  const [activeMode, setActiveMode] = useState("pay");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { CompanyList } = useSelector((state) => state.DataSlice);
  const { loading } = useSelector((state) => state.NmmBuisness);
  const company_id = Cookies.get("company_id");
  console.log(company_id, "company_id");
  const filterOptions = CompanyList.filter((val) => {
    const id = val?.value?.split(":")[0];
    return id !== company_id;
  });
  console.log(filterOptions, "filterOptions");
  useEffect(() => {
    dispatch(companyList());
    AOS.init({ duration: 1000 });
  }, []);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("Recever_company", data.company?.value);
    formData.append("Sender_company", company_id);
    formData.append("Transaction_Date", new Date(data.date).getTime());
    formData.append("amount", data.amount);
    formData.append("mode", data.mode);
    formData.append("Payment_status", data.status);
    formData.append("comment", data.comment);
    
    if (activeMode === "pay") {
      formData.append("payPass", data.payPass);
      const response = await dispatch(insertTransaction(formData));
      if (response.payload.status === "success") {
        toast.success(response.payload.message);
        reset();
        navigate("/Businessimpact");
      } else {
        toast.error(response.payload.message);
      }
    } else {
      const response = await dispatch(insertRequest(formData));
      if (response.payload.status === "success") {
        toast.success(response.payload.message);
        reset();
        navigate("/Businessimpact");
      } else {
        toast.error(response.payload.message);
      }
    }
  };

  return (
    <div className="container-fluid px-3 py-4 bg-white">
      <div className="mb-4 text-center text-md-start fade-content">
        <h1
          className="gradient-heading fw-bold mb-3 d-flex justify-content-center justify-content-md-start"
          data-aos="zoom-in"
        >
          {activeMode === "pay"
            ? "Member to Member Transaction"
            : "Payment Request to Member"}
        </h1>
        <p className="lead text-black" data-aos="fade-up" data-aos-delay="300">
          {activeMode === "pay" ? (
            <>
              To request payment from a member, click the{" "}
              <strong className="text-danger">Request</strong> button.
            </>
          ) : (
            <>
              To make a transaction, click the{" "}
              <strong className="text-danger">Pay</strong> button.
            </>
          )}
        </p>
      </div>

      <div
        className="d-flex justify-content-center justify-content-md-start mb-4"
        data-aos="fade-up"
        data-aos-delay="500"
      >
        <div
          className="position-relative bg-light rounded-pill d-inline-flex align-items-center shadow"
          style={{
            width: "240px",
            height: "48px",
            padding: "4px",
            border: "1px solid #dee2e6",
          }}
        >
          <div
            className="position-absolute bg-dark rounded-pill"
            style={{
              width: "50%",
              height: "calc(100% - 8px)",
              top: "4px",
              left: activeMode === "pay" ? "4px" : "calc(50% + 4px)",
              transition: "left 0.3s ease",
              zIndex: 1,
            }}
          ></div>
          <button
            type="button"
            className={`btn btn-sm w-50 border-0 bg-transparent fw-semibold text-center ${
              activeMode === "pay" ? "text-white" : "text-dark"
            }`}
            onClick={() => setActiveMode("pay")}
            style={{ zIndex: 2 }}
          >
            <i className="bx bx-send me-1"></i> Pay
          </button>
          <button
            type="button"
            className={`btn btn-sm w-50 border-0 bg-transparent fw-semibold text-center ${
              activeMode === "request" ? "text-white" : "text-dark"
            }`}
            onClick={() => setActiveMode("request")}
            style={{ zIndex: 2 }}
          >
            <i className="bx bx-receipt me-1"></i> Request
          </button>
        </div>
      </div>

      <div className="row align-items-center gy-4">
        <div className="col-12 col-md-7 col-lg-7 col-12" data-aos="fade-left">
          <form
            className="p-4 border rounded form-bg"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="mb-3">
              <label className="form-label fw-semibold">Company Name</label>
              <Controller
                name="company"
                control={control}
                rules={{ required: "Company is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={filterOptions}
                    placeholder="Select Company"
                  />
                )}
              />
              {errors.company && (
                <small className="text-danger">{errors.company.message}</small>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Amount</label>
              <input
                type="number"
                className="form-control"
                placeholder="$500"
                {...register("amount", {
                  required: "Amount is required",
                  min: 1,
                })}
              />
              {errors.amount && (
                <small className="text-danger">{errors.amount.message}</small>
              )}
            </div>

            {activeMode === "pay" && (
              <div className="mb-3">
                <label className="form-label fw-semibold">Pay Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter your PayPass"
                  {...register("payPass", {
                    required: "PayPass is required",
                    minLength: { value: 4, message: "At least 4 characters" },
                  })}
                />
                {errors.payPass && (
                  <small className="text-danger">
                    {errors.payPass.message}
                  </small>
                )}
              </div>
            )}

            <div className="mb-4">
              <label className="form-label fw-semibold">
                Mode of Transaction
              </label>
              <div className="d-flex flex-wrap gap-3 mt-2">
                {transactionModes.map((modeLabel, index) => (
                  <div key={modeLabel} className="form-check form-check-inline">
                    <input
                      type="radio"
                      id={`mode-${index}`}
                      value={modeLabel}
                      {...register("mode", { required: "Select a mode" })}
                      className="form-check-input"
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`mode-${index}`}
                    >
                      {modeLabel}
                    </label>
                  </div>
                ))}
              </div>
              {errors.mode && (
                <small className="text-danger">{errors.mode.message}</small>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Payment Status</label>
              <div className="d-flex flex-wrap gap-3">
                {paymentStatuses.map((s) => (
                  <div key={s} className="form-check">
                    <input
                      type="radio"
                      id={s}
                      value={s}
                      {...register("status", { required: "Select a status" })}
                      className="form-check-input"
                    />
                    <label htmlFor={s} className="form-check-label">
                      {s}
                    </label>
                  </div>
                ))}
              </div>
              {errors.status && (
                <small className="text-danger">{errors.status.message}</small>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Transaction Date</label>
              <Controller
                name="date"
                control={control}
                rules={{ required: "Date is required" }}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    selected={field.value}
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                  />
                )}
              />
              {errors.date && (
                <small className="text-danger">{errors.date.message}</small>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Comment</label>
              <textarea
                className="form-control"
                rows="3"
                {...register("comment", {
                  required: "Comment is required",
                  minLength: { value: 3, message: "Minimum 3 characters" },
                })}
                placeholder="Add any notes..."
              />
              {errors.comment && (
                <small className="text-danger">{errors.comment.message}</small>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-dark d-flex align-items-center gap-2 mt-4"
            >
              <i className="bx bx-send"></i> Make Request
            </button>
          </form>
        </div>

        <div
          className="col-sm-12 col-md-5 col-lg-5  text-center"
          data-aos="fade-left"
        >
          <img
            src={
              activeMode === "pay"
                ? "/newLogizell/FreieghtRequest.png"
                : "/newLogizell/FreieghtRequest_2.png"
            }
            alt="Illustration"
            className="img-fluid"
            style={{ maxHeight: "600px", objectFit: "contain" }}
          />
        </div>
      </div>
    </div>
  );
};

export default AddBuisness;
